
import { Options, Vue } from "vue-class-component";

@Options({
  name: "LoginView",
  components: {},
  methods: {
    handleIconClick(node: any, e: any) {
      node.props.suffixIcon =
        node.props.suffixIcon === "eye" ? "eyeClosed" : "eye";
      node.props.type = node.props.type === "password" ? "text" : "password";
    },
  },
})
export default class LoginView extends Vue {
  password = "";
  confirmPassword = "";

  passwordValid() {
    if (this.password.length >= 6) {
      return true;
    }
    return false;
  }
  passwordMatch() {
    if (this.password == this.confirmPassword) {
      return true;
    }
    return false;
  }

  resetPassword() {
    // update account password
    return this.password;
  }
}
